import { render, staticRenderFns } from "./ChangesetList.vue?vue&type=template&id=767514c7&scoped=true&"
import script from "./ChangesetList.vue?vue&type=script&lang=js&"
export * from "./ChangesetList.vue?vue&type=script&lang=js&"
import style0 from "./ChangesetList.vue?vue&type=style&index=0&id=767514c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767514c7",
  null
  
)

export default component.exports